import React, { createContext, useContext, useState, useCallback } from 'react';

export interface PageHeaderInfo {
  title: string;
  subtitle?: string;
  status?: string;
  statusColor?: string;
  rightContent?: React.ReactNode;
}

interface PageHeaderContextType {
  header: PageHeaderInfo | null;
  setHeader: (info: PageHeaderInfo | null) => void;
}

const PageHeaderContext = createContext<PageHeaderContextType>({
  header: null,
  setHeader: () => {},
});

export const PageHeaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [header, setHeaderState] = useState<PageHeaderInfo | null>(null);
  const setHeader = useCallback((info: PageHeaderInfo | null) => setHeaderState(info), []);
  return (
    <PageHeaderContext.Provider value={{ header, setHeader }}>
      {children}
    </PageHeaderContext.Provider>
  );
};

export const usePageHeader = () => useContext(PageHeaderContext);
